import { render } from "./AddQuestionDialog.vue?vue&type=template&id=2c2c4759&scoped=true&lang=pug"
import script from "./AddQuestionDialog.vue?vue&type=script&lang=js"
export * from "./AddQuestionDialog.vue?vue&type=script&lang=js"

import "./AddQuestionDialog.vue?vue&type=style&index=0&id=2c2c4759&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2c4759"]])

export default __exports__